import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@marina/auth';
import { getHomeUrlPathForCurrentMarina } from '../utils/post-auth-home.util';

/** Sends authenticated users from `/` to the same home route as after login (e.g. deck hand → launch board). */
export const defaultHomeRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const auth = inject(AuthService);
  return router.parseUrl(getHomeUrlPathForCurrentMarina(auth));
};
